export type GateMediaType = 'photo' | 'video'

export interface GateSubmissionArgument {
  id: string
  gateId: string
  teamId: string
  userId: string
  mediaUrl: string
  mediaType: GateMediaType
  createdAt: Date
}

export default class GateSubmission {
  readonly id: string
  readonly gateId: string
  readonly teamId: string
  readonly userId: string
  readonly mediaUrl: string
  readonly mediaType: GateMediaType
  readonly createdAt: Date

  constructor(arg: GateSubmissionArgument) {
    this.id = arg.id
    this.gateId = arg.gateId
    this.teamId = arg.teamId
    this.userId = arg.userId
    this.mediaUrl = arg.mediaUrl
    this.mediaType = arg.mediaType
    this.createdAt = arg.createdAt
  }

  static fromPG(row: any): GateSubmission {
    return new GateSubmission({
      id: row.id,
      gateId: row.gate_id,
      teamId: row.team_id,
      userId: row.user_id,
      mediaUrl: row.media_url,
      mediaType: row.media_type,
      createdAt: new Date(row.created_at),
    })
  }

  toPG(): Record<string, unknown> {
    return {
      id: this.id,
      gate_id: this.gateId,
      team_id: this.teamId,
      user_id: this.userId,
      media_url: this.mediaUrl,
      media_type: this.mediaType,
      created_at: this.createdAt.toISOString(),
    }
  }
}
